"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _phone = require("@active/core/phone");
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _isEqual = _interopRequireDefault(require("lodash/fp/isEqual"));
var _locale = require("@active/core/locale");
var _getActiveElement = _interopRequireDefault(require("@active/react-utils/dom/getActiveElement"));
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _FlagSelector = _interopRequireDefault(require("./FlagSelector"));
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["disabled", "onBlur", "onChange", "onFocus", "registerValidate", "value", "menuAutoWidth", "defaultLocale", "defaultRegionCode", "disableBuiltinValidation"];
var BlurRelateActionType = /*#__PURE__*/function (BlurRelateActionType) {
  BlurRelateActionType["BLUR"] = "blur";
  BlurRelateActionType["FLAG_CLICK"] = "flag_click";
  return BlurRelateActionType;
}(BlurRelateActionType || {});
var SEPARATOR = ' ';
var countryCodePattern = /^\+\d{1,3} /;
function removeSymbols(value) {
  return value.replace(/[^0-9]/ig, '');
}
var combineCountryCode = function combineCountryCode(countryCode) {
  return function (phone) {
    return phone ? "+".concat(countryCode).concat(SEPARATOR).concat(phone) : '';
  };
};
var verifyPhoneNumber = function verifyPhoneNumber(phone) {
  return function (region) {
    var localPhoneNumber = phone.replace(countryCodePattern, '');
    return (0, _phone.isPhoneNumberStrict)(localPhoneNumber, {
      regionCode: region.toUpperCase()
    });
  };
};
var IntlPhoneInput = function IntlPhoneInput(_ref, ref) {
  var disabled = _ref.disabled,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    registerValidate = _ref.registerValidate,
    value = _ref.value,
    _ref$menuAutoWidth = _ref.menuAutoWidth,
    menuAutoWidth = _ref$menuAutoWidth === void 0 ? true : _ref$menuAutoWidth,
    _ref$defaultLocale = _ref.defaultLocale,
    defaultLocale = _ref$defaultLocale === void 0 ? '' : _ref$defaultLocale,
    _ref$defaultRegionCod = _ref.defaultRegionCode,
    defaultRegionCode = _ref$defaultRegionCod === void 0 ? 'US' : _ref$defaultRegionCod,
    disableBuiltinValidation = _ref.disableBuiltinValidation,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var defaultRegion = (0, _locale.getRegionCodeFromLocale)(defaultLocale) || defaultRegionCode;
  var _parsePhoneNumber = (0, _phone.parsePhoneNumber)(value !== null && value !== void 0 ? value : ''),
    detectedRegion = _parsePhoneNumber.regionCode,
    _parsePhoneNumber$loc = _parsePhoneNumber.localPhoneNumber,
    localPhoneNumber = _parsePhoneNumber$loc === void 0 ? removeSymbols(value !== null && value !== void 0 ? value : '') : _parsePhoneNumber$loc;
  var initialRegion = detectedRegion || defaultRegion;
  var _React$useState = _react["default"].useState(initialRegion),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    region = _React$useState2[0],
    setRegion = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(localPhoneNumber),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    localPhone = _React$useState4[0],
    setLocalPhone = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(null),
    _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
    internalValue = _React$useState6[0],
    setInternalValue = _React$useState6[1];
  var inputElRef = _react["default"].useRef();
  var inputRef = ref !== null && ref !== void 0 ? ref : inputElRef;
  var flagRef = _react["default"].useRef();
  var blurRelateActions$ = _react["default"].useMemo(function () {
    return new _rxjs.Subject();
  }, []);
  var handleChanges = _react["default"].useCallback(function (newRegion, newPhone) {
    var pn = combineCountryCode((0, _phone.countryCodeOf)(newRegion))(newPhone);
    setInternalValue(pn);
    onChange === null || onChange === void 0 || onChange(pn);
  }, [onChange]);
  var handleInputChange = _react["default"].useCallback(function (e) {
    var phoneNumber = removeSymbols(e.target.value);
    if ((0, _isEqual["default"])(localPhone)(phoneNumber)) return;
    setLocalPhone(phoneNumber);
    handleChanges(region, phoneNumber);
  }, [handleChanges, localPhone, region]);
  var handleFlagChange = _react["default"].useCallback(function (regionCode) {
    setRegion(regionCode);
    handleChanges(regionCode, localPhone);
  }, [localPhone, handleChanges]);
  var handleBlur = _react["default"].useCallback(function (event) {
    blurRelateActions$.next({
      type: BlurRelateActionType.BLUR,
      event: event
    });
  }, [blurRelateActions$]);
  var handleFlagButtonClick = _react["default"].useCallback(function (event) {
    blurRelateActions$.next({
      type: BlurRelateActionType.FLAG_CLICK,
      event: event
    });
  }, [blurRelateActions$]);
  _react["default"].useEffect(function overridePhone() {
    if (value && !(0, _isEqual["default"])(internalValue)(value)) {
      setRegion(initialRegion);
      setLocalPhone(localPhoneNumber);
    }
  }, [value, internalValue, detectedRegion, localPhoneNumber, initialRegion]);
  _react["default"].useEffect(function () {
    if (disableBuiltinValidation) return;
    registerValidate === null || registerValidate === void 0 || registerValidate(function (phone) {
      return (0, _isEmpty["default"])(phone) || verifyPhoneNumber(phone)(region) ? undefined : 'react-ui.validation.invalid';
    });
  }, [registerValidate, region, localPhone, disableBuiltinValidation]);
  _react["default"].useEffect(function filterValidBlur() {
    var subscription = blurRelateActions$.pipe((0, _operators.debounceTime)(0)).pipe((0, _operators.filter)(function (_ref2) {
      var type = _ref2.type;
      return type !== BlurRelateActionType.FLAG_CLICK;
    })).subscribe(function (_ref3) {
      var event = _ref3.event;
      if ((0, _getActiveElement["default"])() !== inputRef.current && (0, _getActiveElement["default"])() !== flagRef.current) {
        onBlur === null || onBlur === void 0 || onBlur(event);
      }
    });
    return function () {
      subscription.unsubscribe();
    };
  }, [blurRelateActions$, inputRef, onBlur]);
  _react["default"].useEffect(function () {
    return function () {
      blurRelateActions$.complete();
    };
  }, [blurRelateActions$]);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, props, {
    disabled: disabled,
    onBlur: handleBlur,
    onChange: handleInputChange,
    onFocus: onFocus,
    value: localPhone,
    preAddon: /*#__PURE__*/_react["default"].createElement(_FlagSelector["default"], {
      menuAutoWidth: menuAutoWidth,
      disabled: disabled,
      onBlur: handleBlur,
      onChange: handleFlagChange,
      onClick: handleFlagButtonClick,
      onFocus: onFocus,
      value: region,
      ref: flagRef
    }),
    ref: inputRef,
    type: "tel"
  }));
};
var Forwarded = (0, _compose["default"])(_react["default"].memo, _react["default"].forwardRef)(IntlPhoneInput);
var _default = exports["default"] = Forwarded;